module.exports = __webpack_public_path__ + "img/type2-bg3.3d975ead.png";